// src/pages/Sources.tsx

import React, {ReactElement, FC} from "react";
import {Box, Typography} from "@mui/material";
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import {useNavigate} from "react-router-dom";

const Sources: FC<any> = (): ReactElement => {

    let navigate = useNavigate();
    
    return (
        <Box sx={{
            flexGrow: 1,
            backgroundColor: 'whitesmoke',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start'
        }}>
            <Grid container>
            <Grid item style={{height: '10px'}} xs={12}/>
            <Grid item xs={1} />
                <Grid item xs={11}>
                    <Typography color="black" variant="h5">
                        Sources
                    </Typography>
                </Grid>
                <Grid item style={{height: '10px'}} xs={12}/>
                <Grid item xs={1} />
                <Grid item xs={10}>
                    <Typography color="black">
                    <p>Hot star density and bar orientation from "Gaia Data Release 3: Mapping the 
asymmetric disc of the Milky Way" by the Gaia Collaboration, R. Drimmel, 
et al. 2022.</p>

<p>Dust from "Three-dimensional extinction maps: Inverting inter-calibrated
extinction catalogues" by J.R. Vergely, R. Lallement and N.L.J. Cox, 2022.</p>

<p>Young star clusters updated from data originally described in "Painting a portrait
of the Galactic disc with its stellar clusters" by T. Cantat-Gaudin, et. al. 2020.</p>

<p>HII region positions determined by known ionizing stars and clusters with
sizes estimated using Douglas Finkbeiner's H-alpha Full Sky Map and
distances taken from "Estimating Distances from Parallaxes. V. Geometric and
Photogeometric Distances to 1.47 Billion Stars in Gaia Early Data Release 3"
by C.A.L. Bailer-Jones et.al. 2021.</p>
                    </Typography>
                </Grid>
                <Grid item xs={1} />
            </Grid>
        </Box>
    );
};

export default Sources;